export enum ERolesId {
  /**
   * @member {number}
   * @Type User type administrator
   * @description user super administrator. has all permissions
   */
  SUPER_ADMIN = 8,
  /**
   * @member {number}
   * @Type User type administrator
   * @description user administrator. user administrator about his agency
   */
  ADMIN = 6,
  /**
   * @member {number}
   * @Type User type agent
   * @description user Broker. Account owner agency
   */
  BROKER = 1,
  /**
   * @member {number}
   * @Type User type agent
   * @description  is  like user broker but have diferente name
   */
  BROKER_MANAGER = 9,
  /**
   * @member {number}
   * @Type User type agent
   * @description user super senior.
   */
  SENIOR = 2,
  /**
   * @member {number}
   * @Type User type agent
   * @description user junior
   */
  JUNIOR = 3,
  /**
   * @member {number}
   * @Type User type Client
   * @description i dont know what is this
   */
  CLIENT = 5
}

export const CRolesId = {
  ...ERolesId
};

export type TRolesId = typeof ERolesId;
